import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=a753e5d6&scoped=true&"
import script from "./smsTemplate.vue?vue&type=script&lang=js&"
export * from "./smsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./smsTemplate.vue?vue&type=style&index=0&id=a753e5d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a753e5d6",
  null
  
)

export default component.exports